<template>
  <section class="tech-panel advice-panel">
    <div class="panel-title dot-title">农事指导建议</div>
    <div class="advice-list">
      <div class="advice-card" v-for="item in adviceList" :key="item.title">
        <div class="circle"></div>
        <div class="info">{{ item.title }}<span class="value">{{ item.text }}</span></div>
      </div>
    </div>
  </section>
</template>

<script setup>
const adviceList = [
  { title: "灌溉建议:", text: "傍晚补水15-20分钟" },
  { title: "追肥建议:", text: "叶面补充磷钾肥" },
  { title: "通风建议:", text: "棚温超32℃开启通风" },
  { title: "植保建议:", text: "雨后重点查叶斑病" },
];
</script>

<style lang="less" scoped>
@import "./guidancePanelShared.less";

.advice-panel {
  padding: 0 24px 26px;
}

.dot-title {
  width: 320px;
  margin-top: 18px;
  padding-left: 28px;
  text-align: left;
  box-sizing: border-box;
}

.dot-title::before {
  left: 0;
  top: 25px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dot-title::after {
  display: none;
}

.advice-list {
  height: calc(100% - 96px);
  display: grid;
  grid-template-rows: repeat(4, minmax(0, 1fr));
  gap: 26px;
  margin-top: 20px;
}

.advice-card {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 20px;
  gap: 20px;
  border: 1px solid rgba(63, 255, 237, 0.6);
  background: linear-gradient(90deg, rgba(5, 100, 91, 0.46), rgba(4, 52, 49, 0.58));
  box-shadow: inset 0 0 22px rgba(50, 255, 235, 0.1);
  text-align: left;
}

.advice-card .circle {
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #55fff1;
  box-shadow: 0 0 9px rgba(85, 255, 241, 0.85);
}

.advice-card .info {
  color: #f4fffd;
  font-size: 36px;
  line-height: 35px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
}

.advice-card span {
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
}
</style>
